import React from 'react';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { List, MagnifyingGlass, Moon, Sun } from '@phosphor-icons/react';
import NotificationBell from '@/components/layout/NotificationBell';

export default function TopBar({
  setSidebarOpen,
  darkMode,
  setDarkMode,
  notificationsUnread,
  badgeCounts,
  notificationItems,
  navigate,
  initials,
  refreshNotifications,
}) {
  return (
    <header className="h-14 flex items-center justify-between px-4 border-b border-border bg-card">
      <div className="flex items-center gap-3">
        <button onClick={() => setSidebarOpen(true)} className="p-2 -ml-2 rounded-md hover:bg-muted md:hidden" data-testid="mobile-menu-btn">
          <List size={24} />
        </button>
        <div className="hidden sm:flex items-center">
          <button
            onClick={() => {
              const event = new KeyboardEvent('keydown', { key: 'k', metaKey: true, ctrlKey: true });
              document.dispatchEvent(event);
            }}
            className="relative flex items-center w-64 h-9 bg-muted/50 rounded-md px-3 text-sm text-muted-foreground hover:bg-muted transition-colors"
            data-testid="global-search-trigger"
          >
            <MagnifyingGlass size={16} className="mr-2" />
            <span>Search contacts, messages...</span>
            <kbd className="absolute right-2 hidden lg:inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground">⌘K</kbd>
          </button>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button onClick={() => setDarkMode(!darkMode)} className="p-2 rounded-md hover:bg-muted transition-colors" data-testid="dark-mode-toggle">
          {darkMode ? <Sun size={20} /> : <Moon size={20} />}
        </button>
        <NotificationBell
          notificationsUnread={notificationsUnread}
          badgeCounts={badgeCounts}
          notificationItems={notificationItems}
          navigate={navigate}
          refreshNotifications={refreshNotifications}
        />
        <div className="md:hidden">
          <Avatar className="w-8 h-8">
            <AvatarFallback className="bg-primary text-primary-foreground text-xs font-medium">
              {initials}
            </AvatarFallback>
          </Avatar>
        </div>
      </div>
    </header>
  );
}
